export const getBrutalistStyles = (isDarkMode) => ({
  // Navegación brutalista
  brutalistNavigation: {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    zIndex: 1000,
    backgroundColor: isDarkMode ? '#1a1a1a' : '#ffffff',
    padding: '1rem',
    '@media screen and (maxWidth: 768px)': {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },

  // Botón de inicio
  brutalistHomeButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#4CAF50',
    color: '#fff',
    border: `3px solid ${isDarkMode ? '#fff' : '#000'}`,
    fontWeight: 700,
    fontSize: '0.9rem',
    cursor: 'pointer',
    boxShadow: `4px 4px 0 ${isDarkMode ? '#fff' : '#000'}`,
    transform: 'translate(-2px, -2px)',
    transition: 'transform 0.1s, box-shadow 0.1s',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    '@media screen and (maxWidth: 768px)': {
      width: '100%',
      justifyContent: 'center'
    }
  },

  // Breadcrumb brutalista
  brutalistBreadcrumb: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.5rem 1rem',
    backgroundColor: isDarkMode ? '#333' : '#fff',
    border: `3px solid ${isDarkMode ? '#fff' : '#000'}`,
    boxShadow: `4px 4px 0 ${isDarkMode ? '#fff' : '#000'}`,
    transform: 'translate(-2px, -2px)',
    '@media screen and (maxWidth: 768px)': {
      width: '100%',
      overflowX: 'auto',
      whiteSpace: 'nowrap'
    }
  },

  brutalistBreadcrumbItem: {
    color: isDarkMode ? '#fff' : '#000',
    textDecoration: 'none',
    fontWeight: 600,
    fontSize: '0.9rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    '&:hover': {
      textDecoration: 'underline'
    }
  },

  brutalistBreadcrumbSeparator: {
    color: isDarkMode ? '#fff' : '#000',
    fontWeight: 700
  },

  // Contenedor de formulario brutalista
  formContainer: {
    maxWidth: '500px',
    margin: '0 auto',
    padding: '2rem'
  },

  // Título brutalista
  brutalistTitle: {
    textAlign: 'center',
    marginBottom: '2rem',
    borderBottom: '4px solid',
    paddingBottom: '0.5rem',
    borderColor: isDarkMode ? '#fff' : '#000',
    textTransform: 'uppercase'
  },

  // Input brutalista
  brutalistInput: {
    padding: '0.75rem',
    border: `3px solid ${isDarkMode ? '#fff' : '#000'}`,
    backgroundColor: isDarkMode ? '#333' : '#fff',
    color: isDarkMode ? '#fff' : '#000',
    fontSize: '1rem',
    width: '100%',
    boxShadow: `4px 4px 0 ${isDarkMode ? '#fff' : '#000'}`,
    transform: 'translate(-2px, -2px)',
    transition: 'transform 0.1s, box-shadow 0.1s'
  },

  // Label brutalista
  brutalistLabel: {
    fontWeight: 700,
    fontSize: '0.9rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },

  // Botón brutalista primario
  brutalistButton: {
    padding: '1rem',
    backgroundColor: '#00B8D4',
    color: '#000',
    border: `3px solid ${isDarkMode ? '#fff' : '#000'}`,
    fontWeight: 700,
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: `6px 6px 0 ${isDarkMode ? '#fff' : '#000'}`,
    transform: 'translate(-3px, -3px)',
    transition: 'transform 0.1s, box-shadow 0.1s',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    width: '100%'
  },

  // Botón brutalista secundario
  brutalistButtonSecondary: {
    padding: '1rem',
    backgroundColor: '#FF3D00',
    color: '#fff',
    border: `3px solid ${isDarkMode ? '#fff' : '#000'}`,
    fontWeight: 700,
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: `6px 6px 0 ${isDarkMode ? '#fff' : '#000'}`,
    transform: 'translate(-3px, -3px)',
    transition: 'transform 0.1s, box-shadow 0.1s',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    width: '100%'
  },

  // Mensaje de error brutalista
  brutalistError: {
    padding: '1rem',
    marginBottom: '1.5rem',
    backgroundColor: '#FF3D00',
    color: '#fff',
    border: '3px solid #000',
    boxShadow: '4px 4px 0 #000',
    transform: 'translate(-2px, -2px)',
    fontWeight: 600
  },

  // Checkbox brutalista
  brutalistCheckbox: {
    width: '1.2rem',
    height: '1.2rem',
    border: `3px solid ${isDarkMode ? '#fff' : '#000'}`,
    backgroundColor: isDarkMode ? '#333' : '#fff',
    cursor: 'pointer'
  },

  // Link brutalista
  brutalistLink: {
    color: isDarkMode ? '#fff' : '#000',
    textDecoration: 'none',
    fontWeight: 600,
    fontSize: '0.9rem',
    borderBottom: `2px solid ${isDarkMode ? '#fff' : '#000'}`
  },

  // Estados de hover para botones
  buttonHoverState: {
    transform: 'translate(-4px, -4px)',
    boxShadow: `8px 8px 0 ${isDarkMode ? '#fff' : '#000'}`
  },

  // Estados deshabilitados
  disabledState: {
    opacity: 0.7,
    cursor: 'not-allowed'
  }
});